import script from "./WapTrainingView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WapTrainingView.vue?vue&type=script&lang=ts&setup=true"

import "./WapTrainingView.vue?vue&type=style&index=0&id=48c462ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48c462ee"]])

export default __exports__